import { backOff } from "exponential-backoff";

/**
 * @deprecated Use cloudfront geo fields like in creator-app-v2 instead.
 */
type IpInfo = {
	readonly country: string | undefined;
	readonly ipAddress: string | undefined;
};

type GetIpInfoOptions = {
	readonly signal: AbortSignal;
};

/**
 * @deprecated Use cloudfront geo fields like in creator-app-v2 instead.
 */
function createIpInfoGeolocationService(token: string) {
	return {
		async getIpInfo(options?: GetIpInfoOptions): Promise<IpInfo | undefined> {
			const signal = options?.signal;
			const url = `https://ipinfo.io/json?token=${token}`;

			let response: Response;
			try {
				response = await backOff(() => fetch(url, { signal }), {
					startingDelay: 500,
					numOfAttempts: 5,
					timeMultiple: 2,
					maxDelay: 4_000,
				});
			} catch (e) {
				console.error("Error response", e);
				return undefined;
			}
			if (!response.ok) {
				console.error("Invalid response");
				return undefined;
			}

			let result: any;
			try {
				result = await response.json();
			} catch {
				console.error("Failed to parse ipinfo.io response");
				return undefined;
			}

			if (typeof result !== "object" || !result || !("country" in result)) {
				return undefined;
			}

			return {
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
				country: result.country ?? undefined,
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
				ipAddress: result.ip ?? undefined,
			} satisfies IpInfo;
		},
	};
}

/**
 * @deprecated Use cloudfront geo fields like in creator-app-v2 instead.
 */
type IpGeolocationService = ReturnType<typeof createIpInfoGeolocationService>;

export type { IpGeolocationService, IpInfo };
export { createIpInfoGeolocationService };
